/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateColorDto = {
    /**
     * Color name
     */
    name?: string;
    /**
     * Color description
     */
    description?: string;
    /**
     * Source of creation
     */
    source?: UpdateColorDto.source;
};
export namespace UpdateColorDto {
    /**
     * Source of creation
     */
    export enum source {
        CATALOG = 'CATALOG',
        SETTINGS = 'SETTINGS',
    }
}

